//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {AppMixin} from '~/node_modules/sitis-nuxt/lib/mixins'
import {actionType as cardActionType} from '~/node_modules/sitis-nuxt/lib/store/modules/cart-store'
import moment from 'moment'
import StockInformation from './StockInformation'
import ShareLinks from '~/components/product/ShareLinks'
import SameProducts from "~/components/product/add-to-cart/SameProducts.vue";
import DialogAuthorizationMyAcuvue from "~/components/common/DialogAuthorizationMyAcuvue.vue";


export default {
  name: 'AddToCartInfo',
  data: function () {
    return {
      isOpenCasePopup: false,
      isHidePaymentShares: true,
      isHidePaymentYandexPay: true,
      isClickAddToCart: false,
      isEkb: false,
      isShowAuthMyAcuvuePopup: false,
    }
  },

  mixins: [AppMixin],
  created() {
    const city = this.$store.getters['appState/config'];
    this.isEkb = Boolean(city?.city?.data?.city_id === 1486209);
  },
  components: {
    ShareLinks,
    SameProducts,
    StockInformation,
    DialogAuthorizationMyAcuvue,
    PopupCaseSelection: () => import('~/components/product/add-to-cart/PopupCaseSelection'),
    ProductNotAvailable: () => import('~/components/product/add-to-cart/ProductNotAvailable'),
  },

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      },
    },

    termDelivery: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isModification: {
      type: Boolean,
      default: false,
    },
    availability: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availabilityAddress: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availabilityNames: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availabilityQuantities: {
      type: Object,
      default: () => {
        return {}
      },
    },
    productPriceModifactions: {
      type: Object,
      default: () => {
        return {}
      },
    },
    refDialogSignUpSelection: {
      type: Object,
      default: () => {
        return {}
      },
    },

    productTermWithoutModification: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isShowButtonMyAcuvue: {
      type: Boolean,
      default: false,
    },
    isInWishlist: {
      type: Boolean,
      default: false,
    },
    activeSameProducts: {
      type: Boolean,
      default: false,
    },
    sameProducts: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    jjDeliveryMessageFromVar() {
      return this.$store.getters['appState/vars']?.['Доставка (в странице товара Казань)'] ? this.$store.getters['appState/vars']?.['Доставка (в странице товара Казань)'] : 'Доставка осуществляется со склада производителя на ваш адрес.' ;
    },
    isJJ() {
      return this.$store.state["local-settings"].isJJ
    },
    customPeriodAvailableDays() {
      return process.env.customPeriodAvailableDays;
    },

    isInCustomListId() {
      const dayAmount = process.env.customPeriodAvailableProductsIds;

      return dayAmount.split(',').some(t => Number(t) === this.product.id);
    },


    showClassesCaseOnCartAdded() {
      return process.env.showClassesCaseOnCartAdded === 'true';
    },
    setSale() {
      if (this.productOldPrice) {
        const sale = 100 - (this.productPrice * 100 / this.productOldPrice)
        return `-${Math.round(sale)}%`
      }
      return false
    },
    isShowOldPrice: function () {
      return Boolean(
        this.product.oldPrice && this.product.oldPrice > this.product.price
      )
    },

    labelBonuses: function () {
      const count = this.product.bonusValue
      if (!count) {
        return
      }

      const label = this.$caseWords(count, ['бонус', 'бонуса', 'бонусов'])

      return `+${this.$numberFormat(count)} ${label}`
    },

    splitPayment: function () {
      const price = this.product.price
      const priceSplit = Math.ceil(price / 4)

      return [
        {
          date: moment().add(0, 'week').format('DD MMM'),
          amount: priceSplit
        },
        {
          date: moment().add(2, 'week').format('DD MMM'),
          amount: priceSplit
        },
        {
          date: moment().add(4, 'week').format('DD MMM'),
          amount: priceSplit
        },
        {
          date: moment().add(6, 'week').format('DD MMM'),
          amount: priceSplit
        },
      ]
    },

    stockAddressProduct: function () {
      const activeCityName = this.appCfg?.city?.model?.name || 'Екатеринбург'
      const addresses = (this.product.stores || []).filter(
        (t) => t.cityName === activeCityName
      )

      if (addresses.length > 0) {
        return addresses
      }

      let cities = [];
      (this.product.stores || []).map((address) => {
        if (!cities.find((t) => t.address === `г. ${address.cityName}`)) {
          const stores = (this.product.stores || []).filter(
            (t) => t.cityName === address.cityName
          )

          cities.push({
            id: address.id,
            address: `г. ${address.cityName}`,
            title: `г. ${address.cityName}`,
            stores: [...stores],
            lat: address.lat,
            lon: address.lon,
          })
        }
      })

      return cities
    },

    buttonMyAcuvues: function () {
      if (!this.isShowButtonMyAcuvue) {
        return []
      }

      const myAcuvueProfile = this.$store.state?.myacuvue?.profile || {}
      const fittedProducts = myAcuvueProfile?.fitted_products || {}
      const isProfileVouchers = myAcuvueProfile?.discount_vouchers || []
      const productId = this.product.id

      let items = []

      // кнопка "Получить скидку на эти линзы в MyACUVUE®"
      if (
        !!this.isShowButtonMyAcuvue &&
        Object.keys(myAcuvueProfile).length <= 0
      ) {
        items.push({
          // label: 'Получить скидку на эти линзы в MyACUVUE®',
          label: 'Получите до 3450 бонусов',
          subtitle: 'Присоединяйтесь к программе MyAcuvue',
          link: '/acuvue',
        })
      }
      // ---------------------------------------------------

      // Кнопка "Вам доступна скидка 300/500 рублей"
      if (isProfileVouchers.length > 0 && fittedProducts[productId]) {
        items.push({
          label: 'Получить скидку на эти линзы в MyACUVUE®',
        })
      }
      // ----------------------------------------------------

      // Кнопка "За покупку вам будут начислено"
      if (fittedProducts[productId] && fittedProducts[productId]?.bonuses > 0) {
        items.push({
          label: `За покупку вам будут начислено ${fittedProducts?.[productId]?.bonuses} баллов MyAcuvue`,
        })
      }
      // ---------------------------------------

      return items
    },

    isAddToCart: function () {
      const productId = this.product.id
      const cartItems = this.$store.state?.cart?.items || []
      const isAdded = Boolean(
        cartItems.find((t) => +t.product.id === +productId)
      )

      if (this.isModification) {
        return Boolean(isAdded && this.isClickAddToCart)
      }

      return Boolean(isAdded && !this.isModification)
    },
    productAddedCart: function () {
      const productId = this.product.id
      const cartItems = this.$store.state?.cart?.items || []

      return cartItems.find((t) => +t.product.id === +productId)?.quantity || 0
    },

    wishButtonIcon: function () {
      if (this.isInWishlist) {
        return require('~/assets/svg/favorites/favorites-fill.svg')
      }

      return require('~/assets/svg/favorites/favorites-outline-mobile.svg')
    },

    infoItems: function () {
      let list = [{
        title: 'самовывоз или курьер',
        link: 'payment-and-delivery#delivery'
      }]

      const productCategoryId = this.product.category.id
      const productBrandName = this.product.brand.name

      if (productCategoryId === 5 && productBrandName === 'ACUVUE') {
        list.unshift({
          title: 'баллы MyAcuvue',
          link: 'acuvue'
        })
      }
      if (productCategoryId === 5 && productBrandName !== 'ACUVUE') {
        list.unshift({
          title: 'бонусные баллы',
          link: 'aktsii/bonusy-pri-pokupke-kontaktnyh-linz'
        })
      }
      if (productCategoryId === 2 || productCategoryId === 3) {
        list.unshift({
          title: 'дисконтная карта',
          link: 'company/klientam/pravila-diskontnoy-sistemy'
        })
      }

      return list
    },

    getStoks: function () {
      if (!this.isModification) {
        return this.getStoksProduct() || []
      }
      return this.getStoksModificationProduct() || []
    },

    isNotAvailable: function () {
      if (this.isProductUnavailableZeroBalance) {
        return true
      }

      return this.product?.isNotAvailable || false
    },
    isProductUnavailableZeroBalance: function () {
      const disabledProductIds = (this.$store.state.appState?.vars?.['ID товаров недоступных при нулевом остатке'] || "").split(",");
      if (Boolean(this.getStoks.find((t) => t.quantity <= 0) && disabledProductIds.includes(String(this.product.id)))) {
        return true
      }
      return false
    },

    productPrice: function () {
      if (this.productPromoPrice?.priceProduct) {
        return this.productPromoPrice?.priceProduct
      }

      return this.calcProductPrice
    },
    productOldPrice: function () {
      if (this.productPromoPrice?.priceProduct) {
        return this.calcProductPrice
      }

      if (!this.isShowOldPrice) {
        return
      }

      return this.product.oldPrice
    },
    calcProductPrice: function () {
      if (Object.keys(this.productPriceModifactions || {}).length > 0) {
        return Object.keys(this.productPriceModifactions).reduce((value, key) => {
          return value + this.productPriceModifactions[key]
        }, 0)
      }

      return this.product.price
    },

    productPromoPrice: function () {
      const productPrice = this.calcProductPrice

      let promotions = (this.product?.promotions || []).filter((promotion) => promotion?.visualProfitType)
      if (promotions.length <= 0) {
        return {}
      }

      let promotionMin = {}
      let minProductPrice = productPrice
      promotions.map((promotion) => {
        const visualProfitType = promotion.visualProfitType
        const visualProfitValue = promotion.visualProfitValue

        let newProductPrice = productPrice
        if (visualProfitType === 'percent') {
          newProductPrice = Math.round(newProductPrice - ((newProductPrice / 100) * Number.parseFloat(visualProfitValue)))
        }
        if (visualProfitType === 'fixed') {
          newProductPrice = newProductPrice - Number.parseFloat(visualProfitValue)
        }

        if (newProductPrice > 0 && newProductPrice < minProductPrice) {
          promotionMin = {
            ...promotion,
            priceProduct: newProductPrice
          }
          minProductPrice = newProductPrice
        }
      })

      return promotionMin
    },

    signUpSelection: function () {
      let signUpSelectionsRegions = process.env.signUpSelectionsRegions
      if (!signUpSelectionsRegions) {
        return {}
      }

      signUpSelectionsRegions = JSON.parse(signUpSelectionsRegions)
      if (signUpSelectionsRegions.length <= 0) {
        return {}
      }

      const regionId = this.$store.state.appState?.config?.city?.model?.region_id
      if (!regionId || !signUpSelectionsRegions.includes(regionId)) {
        return {}
      }

      const categoryName = this.product?.category?.name || ''
      if (!categoryName) {
        return {}
      }

      let type = ''
      let buttonLabel = ''
      if (categoryName === 'Контактные линзы') {
        type = 'mkl'
        buttonLabel = 'Записаться на подбор линз'
      }
      if (categoryName === 'Оправы') {
        type = 'opravy'
        buttonLabel = 'Записаться на подбор очков'
      }
      if (!type) {
        return {}
      }

      return {
        label: buttonLabel,
        type: type,
        visible: true
      }
    },

    //проверяем наличие футляра
    isHaseCase() {
      return (this.product?.characteristics?.[0]?.characteristics || [])
        .filter(t => t?.slug === 'case')
        .map(t => t?.values?.[0])
        .some(t => t.value === 'False' || t.value === 'Нет')
    },

    isOpenSelectCasePopup() {
      return this.isAddToCart && this.isHaseCase && this.isOpenCasePopup && this.product.category.name === 'Оправы'
    },

    isAcuvueProduct: function () {
      return this.product?.characteristics?.find((char) => char.name === 'Основные')?.characteristics?.find((item) => item.slug === 'myacuvuebrandid')
    },
    // проверка пользователя на авторизацию Acuvue
    isUserHasMyAcuvue: function () {
      return Object.keys(this.$store?.state?.myacuvue?.profile)?.length > 0;
    },
    // Вытаскиваем из рекомендованных товар, на который у пользователя есть купон
    fittedProductsWithAcuvuePromo: function () {
      const fitted = this.$store.state?.myacuvue?.profile?.fitted_products || null;
      if (!fitted) {
        return [];
      }
      // разбираем массивоподобный объект в реальный массив для возможности парсинга
      const toArray = Array.isArray(fitted) ? fitted : Object.entries(fitted).map(([key, value]) => {
        if (value && typeof value === 'object') {
          return {
            ...value,
            id:Number(value?.id ?? key),
          };
        }
        return {
          id: Number(key),
          value,
        };
      });
      // колбэк проверки наличия значенйи в promos из стора рекомендованных линз acuvue.fitted_products
      const hasData = function (value) {
        if (!value) return false;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') return Object.keys(value).length > 0;
        return Boolean(value);
      };
      return toArray.filter((t) => hasData(t?.promos));
    },
    //проверяем, рекомендован ли этот товар
    isProductHasFitted: function () {
      const _fittedItem = this.fittedProductsWithAcuvuePromo.find((item) => item?.id === this.product?.id)
      return _fittedItem ? _fittedItem : null;
    },
    // берем лучшую цену для акций из характеристики
    isProductHasAcuvuePromotions: function () {
      const promotionsAcuvue = this.product?.characteristics?.find((item) => item.name === 'Акции MyAcuvue');
      return promotionsAcuvue && promotionsAcuvue?.characteristics?.length > 0 ? promotionsAcuvue?.characteristics : ''
    },

    productPriceFromAcuvuePromo: function () {
      // не авторизован
      if (!this.isUserHasMyAcuvue && this.isProductHasAcuvuePromotions) {
        return `${ this.$numberFormat(this.isProductHasAcuvuePromotions?.[0]?.values?.[0]?.slug)} ₽`;
      }
      //авторизован и есть рекомендации от врача
      if (this.isUserHasMyAcuvue && this.isProductHasFitted) {
        return this.isProductHasFitted ? `${this.$numberFormat(this.isProductHasFitted?.price_from)} ₽` : null;
      }
      return null;
    },

    productPromotionDescriptionFromAcuvuePromo: function () {
      // не авторизован
      if (!this.isUserHasMyAcuvue && this.isProductHasAcuvuePromotions) {
        return this.isProductHasAcuvuePromotions ? this.isProductHasAcuvuePromotions?.[1]?.values?.[0]?.value : '';
      }
      //авторизован и есть рекомендации от врача
      if (this.isUserHasMyAcuvue && this.isProductHasFitted) {
        return this.isProductHasFitted && Object.keys(this.isProductHasFitted?.promos)?.length > 0 ? this.isProductHasFitted?.promos?.description : '';
      }
      return null;
    },

    isGlassesOrFrames() {
      return Boolean(this.product?.category?.id === 2 && this.product?.category?.name === 'Оправы') || Boolean(this.product?.category?.id === 3 && this.product?.category?.name === 'Солнцезащитные очки');
    }
  },

  mounted: async function () {
    this.checkPaymentShares()
    this.checkPaymentUnitPay()
  },

  methods: {
    // Логика добавления товара в коризну
    clickButtonCart: async function () {
      if (this.isAcuvueProduct) {
        this.$yandexMetrika.reachGoal('buy_myacuvue_page_B')
      }

      if (this.isAddToCart && this.isModification) {
        this.$router.push('/cart')
        return
      }

      if (!this.isAddToCart) {
        this.isOpenCasePopup = true
        await this.addToCart()
        return
      }
    },

    onCloseSelectionCasePopup() {
      this.isOpenCasePopup = false
    },

    addToCart: async function () {
      this.isClickAddToCart = true
      await this.$emit('toCart')
    },
    payInstallments: async function () {
      await this.$emit('toCart', {
        payment: 'shares',
      })
    },
    payUnitPay: async function () {
      await this.$emit('toCart', {
        payment: 'unitpay',
      })
    },

    // Провека доступа для оплаты долями
    checkPaymentShares: async function () {
      const isCheckoutPayment8 = await this.$api.agent.transport
        .get(`/payment/info?id=8&product_id=${ this.product?.id }`)
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })

      const productCategoryId = this.product?.category?.id;
      const productAdditionalCategories = this.product?.category?.additionalCategories || [];
      const isCategoryMkl = Boolean(productCategoryId === 5 || productCategoryId === 4)
      const isAdditionalCategoriesMkl = Boolean(productAdditionalCategories.find((t) => t.id === 20 || t.id === 19))

      const productPrice = (this.product?.price || 0)
      this.isHidePaymentShares = Boolean(!isCheckoutPayment8 || isCategoryMkl || isAdditionalCategoriesMkl || productPrice > 30000)
    },

    // Провека доступа для оплаты UnitPay
    checkPaymentUnitPay: async function () {
      const isCheckoutPayment9 = await this.$api.agent.transport
        .get(`/payment/info?id=9&product_id=${ this.product?.id }`)
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })

      this.isHidePaymentYandexPay = Boolean(!isCheckoutPayment9)
    },

    // Логика редактирвание кол-вол товара
    changeQuantityProduct: async function (type) {
      const cartItems = this.$store.state?.cart?.items || []
      const product = cartItems.find((t) => t?.product?.id === this.product.id) || {}

      const url = `cart/${product.id}`

      const newQuantity = Boolean(type === '+')
        ? product.quantity + 1
        : product.quantity - 1

      if (newQuantity === 0) {
        await this.deleteProductFromCard(url)

        return
      }

      const response = await this.$api.agent.transport
        .put(url, {
          quantity: newQuantity,
        })
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          return {error: err.response}
        })
      if (response.error) {
        const errorData = response.error?.data;

        let errorMessage = '';
        if (Array.isArray(errorData)) {
          errorMessage = (errorData || []).map((t) => t.message).join('; <br/>')
        }

        this.$customNotification.error(errorMessage || 'Ошибка изменения количества товара в корзине. Попробуйте позже.')

        return
      }

      this.$yandexCommerce(Boolean(type === '+') ? 'add' : 'remove', [{
        ...this.product,
        quantity: 1
      }])
      await this.updateCartItems()
    },
    deleteProductFromCard: async function (url) {
      const response = await this.$api.agent.transport
        .delete(url)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          return {error: err.response}
        })

      if (response.error) {
        const errorData = response.error?.data;

        let errorMessage = '';
        if (Array.isArray(errorData)) {
          errorMessage = (errorData || []).map((t) => t.message).join('; <br/>')
        }

        this.$customNotification.error(errorMessage || 'Ошибка удаления товара из корзины. Попробуйте позже.')

        return
      }

      this.$yandexCommerce('remove', [{
        ...this.product,
        quantity: 1
      }])

      this.updateCartItems()
    },
    updateCartItems: async function () {
      this.$store.dispatch(`cart/${cardActionType.GET_CART}`)
    },

    // Получение информации о наличии
    getStoksProduct: function () {
      if (Object.keys(this.productTermWithoutModification || {}).length <= 0) {
        return []
      }

      const addresses = this.stockAddressProduct || []
      const hasBluhera = addresses.some(t => t.id === 60);
      const totalCountAddress = addresses.length;

      const item = {
        pickDate: this.productTermWithoutModification?.pickup,
        courierDate: this.productTermWithoutModification?.courier,

        address: addresses,
        totalCountAddress: totalCountAddress,
      }

      return [item]
    },
    _getStoksProduct: function () {
      if (Object.keys(this.productTermWithoutModification || {}).length <= 0) {
        return []
      }

      const addresses = this.stockAddressProduct || []
      const hasBluhera = addresses.some(t => t.id === 60);
      const totalCountAddress = addresses.length;

      const isShowDoubleDays = Boolean(this.product.quantity <= 0 && this.isInCustomListId);
      const pickDateDays = this.setPickDate({hasBluhera, isEkb: this.isEkb});
      const courierDateDays = this.setCourierDate({hasBluhera, isEkb: this.isEkb});

      let pickDate = moment().add(pickDateDays, 'd').format('DD MMMM');
      let courierDate = moment().add(courierDateDays, 'd').format('DD MMMM');

      if (isShowDoubleDays) {
        pickDate = [
          moment().add(pickDateDays, 'd').format('DD MMMM'),
          moment().add(pickDateDays + 2, 'd').format('DD MMMM'),
        ].join(" - ");
        courierDate = [
          moment().add(courierDateDays, 'd').format('DD MMMM'),
          moment().add(courierDateDays + 2, 'd').format('DD MMMM'),
        ].join(" - ");
      }

      const item = {
        pickDate: this.productTermWithoutModification?.pickup,
        courierDate: this.productTermWithoutModification?.courier,

        address: addresses,
        totalCountAddress: totalCountAddress,
      }

      return [item]
    },
    //установка даты доставки на блюхера
    setCourierDate(props) {
      const {
        hasBluhera,
        isEkb
      } = props

      const endTime = moment()
      const beginningTime = moment('17:00', 'h:mm')
      const isTimeEnd = beginningTime.isBefore(endTime)

      if (this.product.quantity <= 0 && this.isInCustomListId) {
        return Number(this.customPeriodAvailableDays);
      }

      if (hasBluhera && isTimeEnd && isEkb) {
        return 1
      }
      if (hasBluhera && !isTimeEnd && isEkb) {
        return 0
      }
      return 3
    },

    //установка даты самовывоза на блюхера
    setPickDate(props) {
      const {
        hasBluhera,
        isEkb
      } = props

      const endTime = moment()
      const beginningTime = moment('21:00', 'h:mm')
      const isTimeEnd = beginningTime.isBefore(endTime)

      if (this.product.quantity <= 0 && this.isInCustomListId) {
        return Number(this.customPeriodAvailableDays);
      }

      if (hasBluhera && isTimeEnd && isEkb) {
        return 1
      }
      if (hasBluhera && !isTimeEnd && isEkb) {
        return 0
      }
      return 2
    },

    getStoksModificationProduct: function () {
      let hasBluhera = false;

      let stocks = []

      Object.keys(this.availability || {}).map((key) => {
        const isJohnsonJohnson = Boolean(((this.product?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'manufacturer')?.values || []).find((t) => t.slug === 'johnson-johnson'))
        const addresses = this.getAddressetStoksModificationProduct(this.availabilityAddress?.[key]);
        const termDelivery = this.termDelivery?.[key];
        const isJJ = this.$store.state['local-settings'].isJJ
        hasBluhera = addresses.some(t => t.id === 60);

        let pickDateLabel = termDelivery?.['pickup'];// || isJohnsonJohnson ? this.vars['Срок доставки (ACUVUE)'] : this.vars['Срок доставки'];
        let courierDateLabel = termDelivery?.['courier'];// || isJohnsonJohnson ? this.vars['Срок доставки (ACUVUE)'] : this.vars['Срок доставки']

        // if (!!isJJ) {
        //   pickDateLabel = this.vars['пункт выдачи JJ']
        //   courierDateLabel = this.vars['курьером JJ']
        // }

        let item = {
          pickDate: pickDateLabel,
          courierDate: courierDateLabel,
          address: addresses,
          totalCountAddress: addresses.length,
          modificationName: this.availabilityNames?.[key] || '',
          quantity: this.availabilityQuantities[key] || 0,
        }
        // let item = {
        //   pickDate: Boolean(addresses.length > 0) ? moment().add(this.setPickDate({
        //     hasBluhera,
        //     isEkb: this.isEkb
        //   }), 'd').format('DD MMMM') : pickDateLabel,
        //   courierDate: Boolean(addresses.length > 0) ? moment().add(this.setCourierDate({
        //     hasBluhera,
        //     isEkb: this.isEkb
        //   }), 'd').format('DD MMMM') : courierDateLabel,
        //   address: addresses,
        //   totalCountAddress: addresses.length,
        //   modificationName: this.availabilityNames?.[key] || '',
        //   quantity: this.availabilityQuantities[key] || 0,
        // }

        stocks.push(item)
      })

      return stocks
    },
    getAddressetStoksModificationProduct: function (initAddresses = []) {
      const activeCityName = this.appCfg?.city?.model?.name || 'Екатеринбург'
      const addresses = (initAddresses || []).filter(
        (t) => t.city_name === activeCityName
      )

      if (addresses.length > 0) {
        return addresses
      }

      const cities = []
      initAddresses.map((address) => {
        if (!cities.find((t) => t.address === `г. ${address.city_name}`)) {
          const stores = initAddresses.filter(
            (t) => t.city_name === address.city_name
          )

          cities.push({
            id: address.id,
            address: `г. ${address.city_name}`,
            title: `г. ${address.city_name}`,
            stores: [...stores],
            lat: address.lat,
            lon: address.lon,
          })
        }
      })

      return cities
    },

    // Открырие информации о магазине
    openStore: function (store) {
      this.$emit('openStore', store)
    },

    // Логика изранного
    clickButtonWish: function () {
      if (this.isInWishlist) {
        this.$emit('removeItemFromWishlist')
        return
      }
      this.$emit('addItemToWishlist')
    },

    changeIsClickAddToCart: function (value) {
      this.isClickAddToCart = value
    },

    openDialogSignUpSelection: function () {
      this.refDialogSignUpSelection.open(this.signUpSelection.type)
    },

    openDialogAuthorizationMyAcuvue: function () {
      this.isShowAuthMyAcuvuePopup = true;
    },
    closeDialogAuthorizationMyAcuvue: function () {
      this.isShowAuthMyAcuvuePopup = false;
    }
  },
}
